<script>
import SustainabilityIndex from './index'
export default SustainabilityIndex
</script>